import { Button, Stack } from "@mantine/core";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import {
  type IAutoPipeRoutingSystemType,
  selectSelectedAutoPipeRoutingSystemType,
  setSelectedAutoPipeRoutingSystemTypeInRedux,
} from "../../pipeRoutingSlice";
import { PRIMARY_SYSTEM_SPECS } from "../../../systemsConstants";

const AUTO_PIPE_ROUTING_SYSTEM_OPTIONS: IAutoPipeRoutingSystemType[] = [
  "SUPPLY_AIR",
  "EXHAUST_AIR",
  "FIRE_PROTECTION",
];

export const AutoPipeRoutingSystemStep = () => {
  const dispatch = useAppDispatch();
  const selectedSystemType = useAppSelector(selectSelectedAutoPipeRoutingSystemType);

  return (
    <Stack gap="xs">
      {AUTO_PIPE_ROUTING_SYSTEM_OPTIONS.map((systemType) => {
        const spec = PRIMARY_SYSTEM_SPECS[systemType];
        const isSelected = selectedSystemType === systemType;

        return (
          <Button
            key={systemType}
            variant={isSelected ? "filled" : "light"}
            color={isSelected ? spec.color : "gray"}
            justify="space-between"
            onClick={() => dispatch(setSelectedAutoPipeRoutingSystemTypeInRedux(systemType))}
            styles={{
              root: {
                height: 56,
              },
              inner: {
                justifyContent: "space-between",
                width: "100%",
              },
            }}
          >
            {spec.label}
          </Button>
        );
      })}
    </Stack>
  );
};
